/**
 * Format a DATE column (no time component) returned by any procedure.
 *
 * DATE values do not carry a timezone — applying `dxtToLocalServerTime` to
 * the midnight DATETIME the .NET serializer emits ("YYYY-MM-DDT00:00:00")
 * would treat it as UTC midnight and roll the date back one day in EDT.
 *
 * Slicing the first 10 characters is the safe, mode-independent way to
 * render a DATE field.
 */
export const formatProxyDate = (
	value: string | Date | null | undefined,
): string => {
	if (value === null || value === undefined || value === "") return "";
	if (typeof value !== "string") {
		const d = value as Date;
		const yyyy = d.getFullYear();
		const mm = String(d.getMonth() + 1).padStart(2, "0");
		const dd = String(d.getDate()).padStart(2, "0");
		return `${yyyy}-${mm}-${dd}`;
	}
	return value.substring(0, 10);
};
